module.exports = __webpack_public_path__ + "static/media/health.7de9ddc8.JPG";